import { gql } from '@apollo/client';

const finance = {
  FINANCE: gql`
    fragment Finance on FinanceResult {
      type
      simulation {
        paymentValue {
          currency
          amount
        }
        interestRate
        comparisonRate
        frequency
        loanTermPeriod {
          value
          unit
        }
        deposits {
          value
          type
        }
        residualValue {
          currency
          amount
        }
        mileage
        financeProduct
        financeAmount {
          amount
          currency
        }
        oneForOne
      }
      editText
    }
  `,
};
export default finance;
